import React from 'react';

const ChevronUp = ({ color, yViewBox = 0 }) => {
  return (
    <svg viewBox={`0 ${yViewBox} 24 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" fill={color} />
    </svg>
  );
};

export default ChevronUp;
